module.exports = __webpack_public_path__ + "img/homecleaning.ab379d5f.png";